import { useState } from "react";
import { setMissingTransactions } from "../../../redux/actions/superadmin/tickets-report";
import useTicketsReportStore, { selectMissingTxns } from "../../../store/superadmin/ticketsReport";
import moment from "moment";
import { useClubsAndLeagues } from "../../../hooks/useClubsAndLeagues";
import useAdminDataStore, { selectCurrentGroupData } from "../../../store/adminData/adminData";

const useTicketsReportData = () => {

  const [selectedClub, setSelectedClub] = useState("");
  const groupData = useAdminDataStore(selectCurrentGroupData);
  const { data: clubsAndLeaguesData, isLoading: clubsAndLeaguesLoading } =
    useClubsAndLeagues(
      groupData?.country,
      groupData?.season,
      groupData?.leagueId,
    );

  const allMissingTransactions = useTicketsReportStore(selectMissingTxns);

  const columns = [
    {
      title: "Time",
      key: "timestamp",
      className: "header-white",
      dataIndex: "timestamp",
      render: (timestamp) =>
        timestamp ? moment(timestamp).format("Do MMM, YYYY") : "-",
      width: window.screen.width > 500 ? 150 : 100,
      sorter: true,
    },
    {
      title: "Group Name",
      key: "groupName",
      className: "header-white",
      dataIndex: "groupName",
      width: window.screen.width > 500 ? 150 : 100,
    },
    {
      title: "Group ID",
      key: "groupId",
      className: "header-white",
      dataIndex: "groupId",
      width: window.screen.width > 500 ? 200 : 150,
    },
    {
      title: "Ticket ID",
      key: "ticketId",
      className: "header-white",
      dataIndex: "ticketId",
      width: window.screen.width > 500 ? 200 : 150,
    },
    {
      title: "Payment ID",
      key: "paymentId",
      className: "header-white",
      dataIndex: "payment_intent",
      width: window.screen.width > 500 ? 300 : 250,
    },
    {
      title: "Total Cost",
      key: "totalCost",
      className: "header-white",
      dataIndex: "totalCost",
      width: window.screen.width > 500 ? 150 : 100,
    },
  ];

  const onClubChange = (e) => {
    setSelectedClub(e.target.value);
    if (!allMissingTransactions?.[e.target.value]) {
      setMissingTransactions(e.target.value);
    }
  };

  return {
    columns,
    clubsAndLeaguesLoading,
    clubsAndLeaguesData,
    selectedClub,
    allMissingTransactions,
    onClubChange,
  };
};

export default useTicketsReportData;
